/**
 * Monetag — REMOVED (2026-07).
 *
 * Monetag served adult / low-quality creatives (vignette / pop-under / push),
 * a brand + App Store risk, so it is FULLY DISABLED in code. It can no longer
 * load regardless of any `REACT_APP_WEB_AD_PROVIDER=monetag` or
 * `REACT_APP_MONETAG_*` deploy secret that may still be set.
 *
 * `purgeMonetag()` also CLEANS UP after earlier builds: it removes any injected
 * Monetag tag scripts and unregisters the `/sw.js` push service worker for
 * users who still carry them. Call it once on app boot.
 *
 * (The web now monetizes only via the premium-aware in-app slots — Ezoic /
 * AdSense when configured, else the "Remove ads" house upsell — see
 * src/lib/webAdProvider.js.)
 */

function removeMonetagTags() {
  if (typeof document === 'undefined') return;
  document.querySelectorAll('script[data-monetag-tag]').forEach((s) => s.remove());
}

function unregisterMonetagServiceWorker() {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator) || !navigator.serviceWorker.getRegistrations) return;
  navigator.serviceWorker.getRegistrations()
    .then((regs) => regs.forEach((r) => {
      if ((r.active?.scriptURL || r.installing?.scriptURL || r.waiting?.scriptURL || '').includes('/sw.js')) {
        r.unregister().catch(() => {});
      }
    }))
    .catch(() => {});
}

/** One-time cleanup: strip any legacy Monetag tag scripts + push service worker. */
export function purgeMonetag() {
  removeMonetagTags();
  unregisterMonetagServiceWorker();
}

// Kept as no-ops so any lingering caller can't break the build. Monetag is off.
export function startMonetag() {}
export function stopMonetag() { purgeMonetag(); }
